/**
 * Cliente da API no ERP Web. Desde a A0 o cliente é o pacote compartilhado
 * `@cafegestor/client` (o mesmo do CaféGestor Vendedor); aqui o Web informa a URL da API
 * (vazia em desenvolvimento: proxy do Vite) e o token do login do Supabase no navegador.
 * As telas continuam importando de `@/lib/api`.
 */
import { configureClient } from "@cafegestor/client";
import { currentAccessToken } from "./supabase";

/** URL base da API. Vazia em desenvolvimento (usa o proxy do Vite). */
export const API_BASE_URL = (import.meta.env["VITE_API_URL"] as string | undefined) ?? "";

configureClient({ baseUrl: API_BASE_URL, getAccessToken: currentAccessToken });

export {
  ApiRequestError,
  apiDownload,
  apiFetch,
  apiFetchBlob,
  errorDetails,
  errorMessage,
  fileToBase64,
  newIdempotencyKey,
  saveBlob,
  type ApiOptions,
} from "@cafegestor/client";
